<template lang="pug">
  div(ref="ClientsListData")
    .clients__list(v-if="loaded")
      clients-item(
        @openCompany="handleOpenCompany"
        v-for="item in items"
        :key="item.id"
        :item="item")

    clients-item-skeleton(
      v-else
      :count="24")

    ui-pagination(
      v-if="showPagination"
      v-model="page"
      :page-count="pageCount"
      @page-change="pageChangeHandler")
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

import ClientsItem from './ClientsItem'
import ClientsItemSkeleton from './ClientsItemSkeleton'
import UiPagination from '@/components/ui/ui-pagination/UiPagination.vue'
import paginationMixin from '@/mixins/pagination.mixin'
import api from '@/api'

export default {
  name: 'ClientsList',

  mixins: [paginationMixin],

  components: {
    UiPagination,
    ClientsItem,
    ClientsItemSkeleton
  },

  mounted: function () {
    this.setupPagination(
      api.dashboard.clients.list,
      {
        user_type: 'client',
        page: this.page,
        // limit: this.limit,
      }
    ).then(() => {
      this.loaded = true
    })
  },

  data: () => ({
    loaded: false,
  }),

  computed: {
    ...mapGetters('dashboard', [
      'clients',
      'countClients'
    ])
  },

  methods: {
    ...mapActions('dashboard', [
      'loadClients',
    ]),
    handleOpenCompany (clientId) {
      this.$store.dispatch('setClientId', clientId)
    },
    async loadItems () {
      this.loaded = false
      const filters = {
        user_type: 'client',
        page: this.page,
      }
      await this.loadClients(filters)
      this.loaded = true
    }
  }
}
</script>
